import { z } from 'zod';

export const AhqFindAccountSchema = z.object({
  accountId: z.string().uuid(),
});
export type AhqFindAccount = z.infer<typeof AhqFindAccountSchema>;
